module.exports = __webpack_public_path__ + "img/logo-paldia-new.864c64ac.png";